import { t } from 'i18next';
export const convertToUnits = (bytes, precision) => {
    const converterPrecision = precision || 1;
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const unitsIndex = Math.floor(Math.log(bytes) / Math.log(1024));
    if (Number.isNaN(bytes) || !isFinite(bytes)) {
        return '-';
    }
    else if (Number(bytes) === 0) {
        return `0 ${t(('CATEGORY_PROPERTIES_SIZE_' + units[0]))}`;
    }
    const size = (bytes / Math.pow(1024, Math.floor(unitsIndex))).toFixed(converterPrecision);
    return `${size} ${t(('CATEGORY_PROPERTIES_SIZE_' + units[unitsIndex]))}`;
};
